const DAILY_RATING_ACTIONS = {
  DAILY_RATING_BACK_LOG_REQUEST: "DAILY_RATING_BACK_LOG_REQUEST",
  DAILY_RATING_BACK_LOG_SUCCESS: "DAILY_RATING_BACK_LOG_SUCCESS",
  DAILY_RATING_BACK_LOG_FAIL: "DAILY_RATING_BACK_LOG_FAIL",
  DAILY_RATING_SUBMIT_SUCCESS: "DAILY_RATING_SUBMIT_SUCCESS",
  NOTIFICATION_ITEM_RATING: "NOTIFICATION_ITEM_RATING",
  CLICK_ITEM_NOTIFICATION: "CLICK_ITEM_NOTIFICATION",
};
export default DAILY_RATING_ACTIONS;
